var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"height":"100px","width":"200px","object-fit":"contain"},attrs:{"src":_vm.$store.state.appConfig.coverImage}})}
var staticRenderFns = []

export { render, staticRenderFns }